  import React, { useState } from "react";
  import { Link } from "react-router-dom";

  export default function Sidebar({ isActive, setIsActive, setShow, show }) {
    return (
        <aside>
          <div className="sidebar">
            <div className="logo-side">
              <Link>
                <img
                  className="big"
                  src={require("../../Assets/Images/side-bar-logo.svg").default}
                />
              </Link>
            </div>
              <div className="side-menu">
              <div>
                {/* <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == ""
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to=""
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="2.5"
                        y="10"
                        width="5"
                        height="6.66667"
                        rx="1"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <rect
                        x="7.5"
                        y="6.66675"
                        width="5"
                        height="10"
                        rx="1"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <rect
                        x="12.5"
                        y="3.33325"
                        width="5"
                        height="13.3333"
                        rx="1"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3.3335 16.6667H15.0002"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p> Analytics</p>
                  </Link>
                </div> */}

                <div className="side-pages">
                  <p>PAGES</p>
                </div>
                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/user"
                        ? "menu-btn bar_active"
                        : "menu-btn"
                    }
                    to={`/user?page=1`}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <ellipse
                        cx="11.0002"
                        cy="6.41667"
                        rx="3.66667"
                        ry="3.66667"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.5 19.25V17.4167C5.5 15.3916 7.14162 13.75 9.16667 13.75H12.8333C14.8584 13.75 16.5 15.3916 16.5 17.4167V19.25"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p> Users</p>
                  </Link>
                </div>

                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/user-verification"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/user-verification?page=1`}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <ellipse
                        cx="8.25016"
                        cy="6.41667"
                        rx="3.66667"
                        ry="3.66667"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.75 19.25V17.4167C2.75 15.3916 4.39162 13.75 6.41667 13.75H10.0833C12.1084 13.75 13.75 15.3916 13.75 17.4167V19.25"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.6665 10.0833L16.4998 11.9167L20.1665 8.25"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>Service providers Verification</p>
                  </Link>
                </div>

                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/service-category" ||
                      window.location.pathname == "/add-categories"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/service-category?page=1`}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.84648 3.0823C10.2075 2.86357 10.6215 2.74792 11.0435 2.74792C11.4656 2.74792 11.8796 2.86357 12.2406 3.0823L17.6305 6.34906C17.9701 6.55487 18.251 6.84477 18.4459 7.19077C18.6408 7.53677 18.7433 7.92718 18.7433 8.32432V8.90334C18.7433 9.10755 18.6622 9.3034 18.5178 9.4478C18.3734 9.5922 18.1776 9.67332 17.9734 9.67332C17.7692 9.67332 17.5733 9.5922 17.4289 9.4478C17.2845 9.3034 17.2034 9.10755 17.2034 8.90334V8.32432C17.2035 8.19186 17.1695 8.0616 17.1046 7.94614C17.0396 7.83068 16.946 7.73392 16.8328 7.66522L11.4429 4.39948C11.3225 4.32643 11.1844 4.28781 11.0435 4.28781C10.9027 4.28781 10.7646 4.32643 10.6442 4.39948L5.25433 7.66522C5.14107 7.73392 5.04746 7.83068 4.98254 7.94614C4.91761 8.0616 4.88357 8.19186 4.88371 8.32432V13.5889C4.88357 13.7214 4.91761 13.8516 4.98254 13.9671C5.04746 14.0826 5.14107 14.1793 5.25433 14.248L9.38963 16.753C9.47612 16.8055 9.55143 16.8744 9.61126 16.956C9.6711 17.0375 9.71428 17.1301 9.73835 17.2283C9.76242 17.3266 9.76691 17.4286 9.75155 17.5285C9.7362 17.6285 9.7013 17.7245 9.64886 17.811C9.59641 17.8975 9.52744 17.9728 9.44589 18.0326C9.36434 18.0924 9.27181 18.1356 9.17357 18.1597C9.07533 18.1838 8.97331 18.1883 8.87333 18.1729C8.77336 18.1575 8.67739 18.1227 8.5909 18.0702L4.45663 15.5652C4.11668 15.3592 3.83564 15.069 3.64068 14.7226C3.44573 14.3762 3.34345 13.9854 3.34375 13.5879V8.32432C3.3438 7.92718 3.44625 7.53677 3.64119 7.19077C3.83613 6.84477 4.11698 6.55487 4.45663 6.34906L9.84648 3.0823Z"
                        fill="#444151"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.8926 10.2635L14.8936 10.2204V9.92681C14.8936 9.7226 14.8125 9.52675 14.6681 9.38235C14.5237 9.23795 14.3278 9.15683 14.1236 9.15683C13.9194 9.15683 13.7235 9.23795 13.5791 9.38235C13.4348 9.52675 13.3536 9.7226 13.3536 9.92681V10.2204L13.3547 10.2635C12.8718 10.3616 12.4123 10.5519 12.0015 10.8241C11.9916 10.8135 11.9813 10.8033 11.9707 10.7933L11.7644 10.5849C11.6184 10.4489 11.4254 10.3748 11.2259 10.3784C11.0264 10.3819 10.8361 10.4627 10.695 10.6038C10.5539 10.7448 10.4731 10.9351 10.4696 11.1346C10.4661 11.3341 10.5401 11.5272 10.6762 11.6731L10.8825 11.8815L10.9133 11.9103C10.6464 12.3148 10.4513 12.7727 10.3517 13.2644C10.3381 13.2638 10.3244 13.2634 10.3107 13.2634H10.017C9.81284 13.2634 9.61699 13.3445 9.47259 13.4889C9.32819 13.6333 9.24707 13.8292 9.24707 14.0334C9.24707 14.2376 9.32819 14.4334 9.47259 14.5778C9.61699 14.7222 9.81284 14.8033 10.017 14.8033H10.3107L10.3497 14.8023C10.4493 15.2951 10.6433 15.753 10.9113 16.1575C10.9014 16.1665 10.8918 16.1757 10.8825 16.1852L10.6751 16.3926C10.5391 16.5385 10.4651 16.7316 10.4686 16.9311C10.4721 17.1306 10.5529 17.3209 10.694 17.462C10.8351 17.603 11.0254 17.6838 11.2249 17.6874C11.4243 17.6909 11.6174 17.6168 11.7634 17.4808L11.9718 17.2734C11.9806 17.2648 11.9891 17.2559 11.9974 17.2467C12.403 17.5147 12.8619 17.7087 13.3547 17.8093L13.3536 17.8463V18.1399C13.3536 18.3441 13.4348 18.54 13.5791 18.6844C13.7235 18.8288 13.9194 18.9099 14.1236 18.9099C14.3278 18.9099 14.5237 18.8288 14.6681 18.6844C14.8125 18.54 14.8936 18.3441 14.8936 18.1399V17.8463V17.8093C15.3864 17.7098 15.8443 17.5147 16.2488 17.2467L16.2754 17.2734L16.4828 17.4818C16.6281 17.622 16.8226 17.6996 17.0245 17.6977C17.2264 17.6959 17.4195 17.6148 17.5622 17.472C17.7049 17.3291 17.7858 17.136 17.7874 16.9341C17.7891 16.7322 17.7114 16.5377 17.5711 16.3926L17.3647 16.1852C17.3554 16.176 17.3458 16.1671 17.336 16.1585C17.6039 15.753 17.7979 15.2941 17.8975 14.8023H18.2302C18.4344 14.8023 18.6302 14.7212 18.7746 14.5768C18.919 14.4324 19.0001 14.2366 19.0001 14.0323C19.0001 13.8281 18.919 13.6323 18.7746 13.4879C18.6302 13.3435 18.4344 13.2624 18.2302 13.2624H17.9365L17.8955 13.2644C17.7971 12.7811 17.6065 12.3213 17.3339 11.9103L17.3647 11.8815L17.5721 11.6741C17.7124 11.529 17.7901 11.3345 17.7885 11.1326C17.7868 10.9308 17.7059 10.7376 17.5632 10.5948C17.4205 10.4519 17.2274 10.3709 17.0256 10.369C16.8237 10.3672 16.6291 10.4447 16.4839 10.5849L16.2754 10.7923L16.2457 10.8231C15.8348 10.5513 15.3754 10.3613 14.8926 10.2635ZM14.1236 11.7265C13.8201 11.7261 13.5196 11.7856 13.2392 11.9015C12.9587 12.0175 12.7039 12.1876 12.4893 12.4022C12.2748 12.6167 12.1046 12.8716 11.9887 13.152C11.8727 13.4324 11.8133 13.733 11.8137 14.0364C11.8133 14.3399 11.8727 14.6405 11.9887 14.9209C12.1046 15.2013 12.2748 15.4561 12.4893 15.6707C12.7039 15.8853 12.9587 16.0554 13.2392 16.1714C13.5196 16.2873 13.8201 16.3468 14.1236 16.3464C14.4271 16.3468 14.7276 16.2873 15.0081 16.1714C15.2885 16.0554 15.5433 15.8853 15.7579 15.6707C15.9725 15.4561 16.1426 15.2013 16.2585 14.9209C16.3745 14.6405 16.434 14.3399 16.4335 14.0364C16.434 13.733 16.3745 13.4324 16.2585 13.152C16.1426 12.8716 15.9725 12.6167 15.7579 12.4022C15.5433 12.1876 15.2885 12.0175 15.0081 11.9015C14.7276 11.7856 14.4271 11.7261 14.1236 11.7265Z"
                        fill="#444151"
                      />
                    </svg>

                    <p>Service Category</p>
                  </Link>
                </div>
                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/report"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/report?page=1`}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.9375 0.6875C6.27962 0.6875 4.125 2.84212 4.125 5.5C4.125 8.15788 6.27962 10.3125 8.9375 10.3125C11.5954 10.3125 13.75 8.15788 13.75 5.5C13.75 2.84212 11.5954 0.6875 8.9375 0.6875ZM5.5 5.5C5.5 3.60147 7.03897 2.0625 8.9375 2.0625C10.836 2.0625 12.375 3.60147 12.375 5.5C12.375 7.39853 10.836 8.9375 8.9375 8.9375C7.03897 8.9375 5.5 7.39853 5.5 5.5ZM6.71344 11.6875C3.38491 11.6875 0.6875 14.3852 0.6875 17.7134C0.6875 19.7007 2.299 21.3125 4.28656 21.3125H13.5884C15.5757 21.3125 17.1875 19.701 17.1875 17.7134C17.1875 14.3849 14.4898 11.6875 11.1616 11.6875H6.71344ZM2.0625 17.7134C2.0625 15.1442 4.14459 13.0625 6.71344 13.0625H11.1616C13.7308 13.0625 15.8125 15.1446 15.8125 17.7134C15.8125 18.3033 15.5782 18.869 15.1611 19.2861C14.744 19.7032 14.1783 19.9375 13.5884 19.9375H4.28656C3.6967 19.9375 3.13101 19.7032 2.71391 19.2861C2.29682 18.869 2.0625 18.3033 2.0625 17.7134Z"
                        fill="#444151"
                      />
                      <path
                        d="M17.1875 8.9375C17.0052 8.9375 16.8303 8.86507 16.7014 8.73614C16.5724 8.6072 16.5 8.43234 16.5 8.25V1.375C16.5 1.19266 16.5724 1.0178 16.7014 0.888864C16.8303 0.759933 17.0052 0.6875 17.1875 0.6875C17.3698 0.6875 17.5447 0.759933 17.6736 0.888864C17.8026 1.0178 17.875 1.19266 17.875 1.375V8.25C17.875 8.43234 17.8026 8.6072 17.6736 8.73614C17.5447 8.86507 17.3698 8.9375 17.1875 8.9375ZM17.1875 11C17.0052 11 16.8303 10.9276 16.7014 10.7986C16.5724 10.6697 16.5 10.4948 16.5 10.3125C16.5 10.1302 16.5724 9.9553 16.7014 9.82636C16.8303 9.69743 17.0052 9.625 17.1875 9.625C17.3698 9.625 17.5447 9.69743 17.6736 9.82636C17.8026 9.9553 17.875 10.1302 17.875 10.3125C17.875 10.4948 17.8026 10.6697 17.6736 10.7986C17.5447 10.9276 17.3698 11 17.1875 11Z"
                        fill="#444151"
                      />
                    </svg>

                    <p>Report</p>
                  </Link>
                </div>
                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/support"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/support?page=1`}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3.6665"
                        y="11.9165"
                        width="3.66667"
                        height="5.5"
                        rx="1.83333"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <rect
                        x="14.6665"
                        y="11.9165"
                        width="3.66667"
                        height="5.5"
                        rx="1.83333"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3.6665 13.7498V10.9998C3.6665 6.94975 6.94975 3.6665 10.9998 3.6665C15.0499 3.6665 18.3332 6.94975 18.3332 10.9998V13.7498"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.5 17.4165C16.5 18.9353 14.0376 20.1665 11 20.1665"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>Support</p>
                  </Link>
                </div>

                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/notification"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/notification?page=1`}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.1665 4.58333C9.1665 3.57081 9.98732 2.75 10.9998 2.75C12.0124 2.75 12.8332 3.57081 12.8332 4.58333C14.9783 5.59767 16.3886 7.71306 16.4998 10.0833V12.8333C16.6397 13.9891 17.3201 15.0097 18.3332 15.5833H3.6665C4.67953 15.0097 5.35994 13.9891 5.49984 12.8333V10.0833C5.61109 7.71306 7.02135 5.59767 9.1665 4.58333"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.25 15.5835V16.5002C8.25 18.0189 9.48122 19.2502 11 19.2502C12.5188 19.2502 13.75 18.0189 13.75 16.5002V15.5835"
                        stroke="#2F2B3D"
                        stroke-opacity="0.9"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p>Notifications</p>
                  </Link>
                </div>
                <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/transaction"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/transaction`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 48 48"
                      id="Receipt-Fill--Streamline-Outlined-Fill-Material"
                      height="22"
                      width="22"
                    >
                      <path
                        fill="#000000"
                        d="M6 43.9498v-39.9l3 3 3 -3 3 3 3 -3 3 3 3 -3 3 3 3 -3 3 3 3 -3 3 3 3 -3v39.9l-3 -3 -3 3 -3 -3 -3 3 -3 -3 -3 3 -3 -2.9925 -3 2.9925 -3 -2.9925 -3 2.9925 -3 -2.9925 -3 2.9925Zm5.85 -10.75h24.5v-3h-24.5v3Zm0 -7.7h24.5v-3h-24.5v3Zm0 -7.75h24.5v-3h-24.5v3Z"
                        stroke-width="1"
                      />
                    </svg>
                    <p>Bookings</p>
                  </Link>
                </div>

                 {/* <div className="side-btm-space">
                  <Link
                    className={
                      window.location.pathname == "/unaccepted-booking"
                        ? "menu-btn bar_active"
                        : "menu-btn "
                    }
                    to={`/unaccepted-booking`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 48 48"
                      id="Receipt-Fill--Streamline-Outlined-Fill-Material"
                      height="22"
                      width="22"
                    >
                      <path
                        fill="#000000"
                        d="M6 43.9498v-39.9l3 3 3 -3 3 3 3 -3 3 3 3 -3 3 3 3 -3 3 3 3 -3 3 3 3 -3v39.9l-3 -3 -3 3 -3 -3 -3 3 -3 -3 -3 3 -3 -2.9925 -3 2.9925 -3 -2.9925 -3 2.9925 -3 -2.9925 -3 2.9925Zm5.85 -10.75h24.5v-3h-24.5v3Zm0 -7.7h24.5v-3h-24.5v3Zm0 -7.75h24.5v-3h-24.5v3Z"
                        stroke-width="1"
                      />
                    </svg>
                    <p>Unaccepted Bookings</p>
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </aside>
    );
  }
